module.exports = __webpack_public_path__ + "static/img/1.9f79478.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/exercicies/words-attack/1.png
// module id = 850
// module chunks = 2 3 4 5